import type { Order } from '@src/domains/orders/types/order';
import { getSaleItems, type DetailedSaleItem } from '@src/domains/sales';

export const getOrderSaleItems = (order: Order): DetailedSaleItem[] =>
  order.sales.reduce((arr, sale) => [...arr, ...getSaleItems(sale)], [] as DetailedSaleItem[]);
